// gatsby-browser.js
import React, { useContext } from "react";
import { Amplify } from "aws-amplify";
import awsmobile from "./src/aws-exports";
import GlobalContextProvider, {
  GlobalDispatchContext,
  GlobalStateContext,
} from "./src/context/GlobalContextProvider";
import { AuthProvider } from "./src/components/Auth/authContext";
import ServicesModal from "components/Modal/ServicesModal";
import { enforceWorkspaceTenant } from "./src/utils/workspaceGate";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

Amplify.configure(awsmobile);

export const registerServiceWorker = () => false; // was true

export const onClientEntry = async () => {
  await enforceWorkspaceTenant({
    workspaceSuffix: ".bimeco.io",
    publicRedirectHost: "bimeco.io",
  });

  const id = "google-font-poppins";
  if (document.getElementById(id)) return;

  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href =
    "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap";
  document.head.appendChild(link);
};


export const wrapRootElement = ({ element }) => {
  return (
    <GlobalContextProvider>
      <AuthProvider>{element}</AuthProvider>
    </GlobalContextProvider>
  );
};

function PageShell({ element, location }) {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);

  const contactLayer = state?.contactLayer || { show: false, message: "" };

  const setLayer = () => {
    dispatch({
      type: "TOGGLE_CONTACT",
      payload: {
        contactLayer: {
          show: !contactLayer.show,
          message: "",
        },
      },
    });
  };

  return (
    <>
      {element}
      {contactLayer.show && (
        <ServicesModal
          formTitle="Get in Touch"
          setShowModal={setLayer}
          category="question"
          msg={contactLayer.message}
        />
      )}
    </>
  );
}

export const wrapPageElement = ({ element, props }) => {
  const p = props?.location?.pathname || "";

  const isViewer = p.startsWith("/stp-viewer") || p.startsWith("/ifc-viewer");
  if (isViewer) return element;

  return <PageShell element={element} location={props?.location} />;
};

export const onRouteUpdate = async () => {
  await enforceWorkspaceTenant({
    workspaceSuffix: ".bimeco.io",
    publicRedirectHost: "bimeco.io",
  });
};
